import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

const handleSpacing = level => {
	switch (level) {
		case 1:
			return '0';
		case 2:
			return '0 0 0 10px';
		case 3:
			return '0 0 0 20px';
		case 4:
			return '0 0 0 30px';
		default:
			return '0';
	}
};

export const Content = styled.div`
	vertical-align: middle;
	word-break: break-word;
`;

export const TableRow = styled.tr`
	transition: all 0.3s linear 0s;
	position: ${props =>
		(props.group === 1 || props.group === 2) && props.level === 1 && 'sticky'};
	top: ${props =>
		(props.group === 1 || props.group === 2) && props.level === 1 && '46px'};
	z-index: ${props =>
		(props.group === 1 || props.group === 2) && props.level === 1 && '11'};
	background: ${props =>
		(props.group === 1 || props.group === 2) && props.level === 1
			? `${colors.grey200}`
			: `${colors.grey100}`};
	border-bottom: 1px solid #d4d4d4;
`;
// border-bottom:1px solid #d4d4d4

export const TableCellGroup = styled.td`
	padding: 20px 0 20px 7px;
	vertical-align: middle;
`;

export const TableCellPeerCount = styled.td`
	width: 8%;
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellMin = styled.td`
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellClassification = styled.td`
	width: 9%;
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellChart = styled.td`
	width: 30%;
	padding: 0 5px 0;
	overflow: hidden;
`;

export const TableCellMax = styled.td`
	padding: 0 5px 0;
	text-align: center;
`;

export const TableCellGroupDiv = styled.div`
	width: 100%;
	display: flex;
	justify-content: start;
	transition: all 1s ease-in-out;
	padding: ${({ level }) => handleSpacing(level)};

	button {
		visibility: ${({ level }) => level === 4 && 'hidden'};
	}
`;

export const ToggleButton = styled.button`
	border: none;
	padding: 0;
	height: 20px;
	cursor: pointer;
	&:hover {
		svg {
			fill: #5cb335;
		}
	}
`;

export const Label = styled.label`
	font-size: 15px;
`;
